window.slideshowData = function () {
  "use strict";

  //.slider-for
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });

  //.slider-nav
  $('.slider-nav').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    arrows: false,
    centerMode: true,
    focusOnSelect: true
  });

  $(window).resize(function () {
    $('#slider-image').not('.slick-initialized').slick('resize');
    $('#slider-nav').not('.slick-initialized').slick('resize');
  });

  $(window).on('orientationchange', function () {
    $('#slider-image').not('.slick-initialized').slick('resize');
    $('#slider-nav').not('.slick-initialized').slick('resize');
  });

}
